<template>
  <button @click.stop="userRecentQueriesStore.clearQueries()"
          class="clear-queries-btn q-btn q-btn-sm">{{ SmartSearchTranslations.userRecentQueries.clearButton }}
  </button>
</template>
<script setup lang="ts">
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";
import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";

const userRecentQueriesStore = useUserRecentQueriesStore()
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
</script>
<style scoped>
.clear-queries-btn {
  font-size: 8px!important;
  text-decoration: underline;
}
</style>
